import React, { Component } from 'react';
import HowToLayout from './HowToLayout';

class HowToCommunity extends Component {
    render() {
        return (
            <HowToLayout title="Community">
                <p className="howto-intro">
                    The <strong className="howto-strong">Community</strong> tab is where meetups happen. It's a feed of events near you that you can join, save for later, or create yourself. Use the filter and itinerary tools at the top to find events and keep track of the ones you care about.
                </p>

                <section className="howto-section">
                    <h3 className="howto-section-title" style={{fontFamily: "'Chelsea Market', cursive"}}>Creating an Event</h3>
                    <p className="howto-paragraph">
                        Tap the <strong className="howto-strong">+</strong> button to open <strong className="howto-strong">Create Event</strong>. Give it a title and description, set the date, time, and an optional end time, and search for a location. You can also set the vibe (Food, Drinks, Coffee, Gaming, Karaoke, Watch Party, and more), a max number of attendees, an age range, who's welcome, and which account types can join. Tap <strong className="howto-strong">Create Event</strong> to publish it — you're now the host.
                    </p>
                </section>

                <section className="howto-section">
                    <h3 className="howto-section-title" style={{fontFamily: "'Chelsea Market', cursive"}}>Joining an Event</h3>
                    <p className="howto-paragraph">
                        Tap an event to open its details, then tap <strong className="howto-strong">Join Event</strong>. It's added to your itinerary under <strong className="howto-strong">Attending</strong> and the button switches to <strong className="howto-strong">Leave Event</strong> if your plans change. Some events ask that you be verified or premium to join.
                    </p>
                </section>

                <section className="howto-section">
                    <h3 className="howto-section-title" style={{fontFamily: "'Chelsea Market', cursive"}}>Saving an Event</h3>
                    <p className="howto-paragraph">
                        Not ready to commit? Tap <strong className="howto-strong">Save Event</strong> (the bookmark icon) to keep it for later without joining. Saved events appear in your itinerary under <strong className="howto-strong">Saved</strong>, and you can tap <strong className="howto-strong">Unsave Event</strong> anytime.
                    </p>
                </section>

                <section className="howto-section">
                    <h3 className="howto-section-title" style={{fontFamily: "'Chelsea Market', cursive"}}>Filtering Events</h3>
                    <p className="howto-paragraph">
                        Tap the <strong className="howto-strong">filter</strong> icon to narrow the feed by time of day, distance, and date (Today, Tomorrow, This Weekend, and more). Premium members get extra filters like location, age range, host gender, who's welcome, and shared anime titles. Tap <strong className="howto-strong">Apply Filters</strong> to update the feed, or <strong className="howto-strong">Reset</strong> to clear them.
                    </p>
                </section>

                <section className="howto-section">
                    <h3 className="howto-section-title" style={{fontFamily: "'Chelsea Market', cursive"}}>Your Events Itinerary</h3>
                    <p className="howto-paragraph">
                        Tap the <strong className="howto-strong">calendar</strong> icon to open your <strong className="howto-strong">Events Itinerary</strong>, which keeps everything in one place across four tabs:
                    </p>
                    <ul className="howto-list">
                        <li><strong className="howto-strong">Attending</strong> — upcoming events you've joined.</li>
                        <li><strong className="howto-strong">Hosting</strong> — upcoming events you created.</li>
                        <li><strong className="howto-strong">Saved</strong> — events you bookmarked to decide on later.</li>
                        <li><strong className="howto-strong">History</strong> — past events you attended or hosted.</li>
                    </ul>
                </section>

                <section className="howto-section">
                    <h3 className="howto-section-title" style={{fontFamily: "'Chelsea Market', cursive"}}>Hosting an Event</h3>
                    <p className="howto-paragraph">
                        For events you host, the details screen gives you extra controls:
                    </p>
                    <ul className="howto-list">
                        <li><strong className="howto-strong">Reveal Meetup Address</strong> — share the exact spot when you're ready.</li>
                        <li><strong className="howto-strong">Initiate Group Chat</strong> — let attendees coordinate together.</li>
                        <li><strong className="howto-strong">Lock Event</strong> — finalize the guest list.</li>
                        <li><strong className="howto-strong">Edit Event</strong> — update the details.</li>
                        <li><strong className="howto-strong">Cancel Event</strong> — call it off if plans fall through.</li>
                    </ul>
                    <p className="howto-paragraph">
                        You can also remove an attendee by tapping their photo.
                    </p>
                </section>

                <section className="howto-section">
                    <h3 className="howto-section-title" style={{fontFamily: "'Chelsea Market', cursive"}}>Attending an Event</h3>
                    <p className="howto-paragraph">
                        On an event you've joined, you can tap <strong className="howto-strong">Leave Event</strong> to drop out, <strong className="howto-strong">Hide Event</strong> to remove it from your feed, or <strong className="howto-strong">Report event</strong> if something's wrong with it. The exact address stays hidden until the host reveals it.
                    </p>
                </section>

                <p className="howto-footer-note">
                    Still need a hand? Email <a href="mailto:hello@animates.app" className="howto-link">hello@animates.app</a>.
                </p>
            </HowToLayout>
        );
    }
}

export default HowToCommunity;
